// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"details-modal_modalWrapper__wCh9G"};